var $2083b83b84266bb4$exports = {};
$2083b83b84266bb4$exports = {
    "loading": `Loading\u{2026}`,
    "loadingMore": `Loading more\u{2026}`
};


export {$2083b83b84266bb4$exports as default};
//# sourceMappingURL=en-US.module.js.map
